@let settingsValue = settings();
@let showArchiveValue = showArchive();
@let serverErrorValue = serverError();
@let routeNameValue = routeName();

<mat-drawer-container autosize class="route-fcst-drawer-container">
  <mat-drawer #drawer class="custom-sidenav-panel" mode="over" position="end">
    <button mat-icon-button class="close-button" (click)="drawer.toggle()">
      <fa-icon [icon]="['far', 'times']"></fa-icon>
    </button>
    <h3>
      <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon> &nbsp;
      {{ 'HOME.SETTINGS' | translate }}
    </h3>
    <p>
      <b>{{ 'PRODUCT.ROUTEFCST.toolTip.transparent' | translate }}</b>
    </p>
    <div class="opacity-slider">
      <ngx-slider
        [value]="settingsValue.backgroundOpacity"
        [options]="opacityOptions"
        (userChange)="onBackgroundOpacityChange($event)"></ngx-slider>
    </div>

    <mat-divider></mat-divider>
    @if (allowDesignChange()) {
      <p><b>Anordnung</b></p>
      <mat-slide-toggle
        class="toggle-margin"
        color="primary"
        [checked]="settingsValue.designMapLeft"
        (change)="onDesignChange($event)">
        Karte {{ settingsValue.designMapLeft ? 'links' : 'rechts' }}
      </mat-slide-toggle>
      <mat-divider></mat-divider>
    }
    <p>
      <button mat-raised-button color="primary" (click)="onResetSettings()">
        {{ 'PRODUCT.RADAR.RESET' | translate }}
      </button>
    </p>
  </mat-drawer>

  <div class="settings-button-stack">
    <button
      mat-mini-fab
      class="settings-button"
      (click)="drawer.toggle()"
      tp="{{ 'HOME.SETTINGS' | translate }}"
      variation="popper"
      trigger="mouseenter"
      tpPlacement="left">
      <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon>
    </button>

    <ng-container>
      <app-print-button
        style="display: none"
        #printButtonComponent
        componentName="route-fcst"></app-print-button>
      <ng-content
        *ngTemplateOutlet="
          printButtonComponent.printButtonTemplate()
        "></ng-content>
    </ng-container>
  </div>
  <div class="base-container">
    <a id="start"></a>

    <!-- FEHLERFREIER SERVER-STATE -->
    @if (!serverErrorValue) {
      <div class="route-fcst-grid-layout">
        <div class="grid-zone-map">
          <ng-container *ngTemplateOutlet="cardMap"></ng-container>
        </div>
        <div class="grid-zone-infobox">
          <ng-container *ngTemplateOutlet="cardInfoBox"></ng-container>
        </div>
      </div>
    }

    <!-- SERVER INTERRUPT STATE -->
    @if (serverErrorValue) {
      <mat-card appearance="outlined" class="route-server-error-card">
        <div class="error-card-content">
          <fa-icon
            [icon]="['far', 'exclamation-triangle']"
            size="lg"
            class="error-icon"></fa-icon>
          <span
            >Der Server antwortet nicht. Bitte versuchen Sie es später noch
            einmal.</span
          >
        </div>
      </mat-card>
    }
  </div>
</mat-drawer-container>

<!-- ========================================== -->
<!-- TEMPLATE: CARD INFOBOX (RECHTS / LINKS)     -->
<!-- ========================================== -->
<ng-template #cardInfoBox>
  <mat-card appearance="outlined" class="route-grid-card-item">
    <mat-card-header class="route-card-header-zone">
      <div class="route-header-title-flex">
        <fa-icon
          mat-card-avatar
          [icon]="['far', 'road']"
          size="lg"
          class="header-avatar-icon"></fa-icon>
        <div class="route-title-text-group">
          <mat-card-title class="route-main-title">{{
            routeNameValue
          }}</mat-card-title>
          <mat-card-subtitle class="route-sub-title">{{
            'PRODUCT.ROUTEFCST.TITLE' | translate
          }}</mat-card-subtitle>
        </div>
      </div>

      <!-- Letztes Update Zeitstempel -->
      <div class="route-header-update-badge">
        <fa-icon [icon]="['far', 'sync-alt']" class="update-icon"></fa-icon>
        <span>
          {{ 'PRODUCT.EPP.LAST_UPDATE' | translate }}:
          <strong>
            {{
              runTimeDtg()
                | datex: 'HH:mm' : undefined : languageService.langSignal()
            }}
          </strong>
        </span>
      </div>
    </mat-card-header>

    @if (detailsData() | isNil: false) {
      <mat-card-content class="route-card-content-zone">
        <app-route-fcst-info
          [detailsData]="detailsData()"
          (jumpTo)="onJumpToSituation($event)"
          [stations]="routeProduct['stations']"
          [lastSelectedAddress]="lastSelectedAddress">
        </app-route-fcst-info>
      </mat-card-content>
    }
  </mat-card>
</ng-template>

<!-- ========================================== -->
<!-- TEMPLATE: CARD MAP (LINKS / RECHTS)        -->
<!-- ========================================== -->
<ng-template #cardMap>
  @let selectedParameterValue = selectedParameter();
  <mat-card
    appearance="outlined"
    class="route-grid-card-item"
    [class.archive-mode-active]="showArchive()">
    <!-- Der blinkende Indikator-Punkt am Rand der Karte -->
    @if (showArchive()) {
      <div class="archive-live-dot" [matTooltip]="'Archiv-Modus aktiv'">
        <span class="dot-core"></span>
        <span class="dot-pulse"></span>
        <span class="dot-text">Archive-Mode</span>
      </div>
    }
    <!-- Karten-Kopfzeile (Parameter, Titel & Archiv) -->
    <div class="route-map-toolbar-header">
      <!-- Spalte 1: Wetter-Parameter Knöpfe -->
      <div class="route-map-parameter-pill-box">
        @for (parameter of routeParameters; track $index) {
          <button
            mat-icon-button
            [ngClass]="[
              parameter === selectedParameterValue
                ? 'param-toggle-btn is-active'
                : 'param-toggle-btn',
              'param-type-' + parameter,
            ]"
            (click)="onParameterSelect(parameter)"
            [matTooltip]="'PRODUCT.ROUTEFCST.toolTip.' + parameter | translate">
            <ng-container
              appWmIcon
              [inputParameter]="parameter"
              [additionalClasses]="['ew-icon-size']"></ng-container>
          </button>
        }
      </div>

      <!-- Spalte 2: Dynamischer Parameter-Titel -->
      <div class="route-map-selected-parameter-title">
        {{ 'PRODUCT.ROUTEFCST.toolTip.' + selectedParameterValue | translate }}
      </div>

      <!-- Spalte 3: Archiv Umschalter & Kalender -->
      <div class="route-map-archive-inline-control">
        <mat-slide-toggle
          class="custom-color-switch route-archive-switch"
          color="primary"
          [checked]="showArchiveValue"
          (change)="onSetShowArchive($event)">
          {{ 'PRODUCT.ROUTEFCST.Archive' | translate }}
        </mat-slide-toggle>

        <!-- Kalender-Slide-Out (Horizontal bündig) -->
        <div
          class="route-calendar-slide-wrapper"
          [class.is-slide-open]="showArchiveValue">
          <mat-form-field
            appearance="fill"
            subscriptSizing="dynamic"
            class="pigeons-date-picker route-date-picker"
            (click)="picker.open()">
            <mat-label>{{
              'PRODUCT.ROUTEFCST.DATESELECT' | translate
            }}</mat-label>
            <input
              matInput
              [min]="minArchiveDate"
              [max]="maxArchiveDate"
              [formControl]="archiveDateControl"
              [matDatepicker]="picker"
              (dateChange)="onArchiveDateChange($event)" />
            <mat-datepicker-toggle matIconSuffix [for]="picker">
              <fa-icon
                matDatepickerToggleIcon
                [icon]="['far', 'calendar-alt']"
                transform="shrink-2"></fa-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>

    <mat-divider class="route-divider"></mat-divider>

    <!-- Slider Sektion -->
    <div class="route-slider-bar-zone">
      <div class="route-ngx-slider-container">
        @if (showArchiveValue === false) {
          @let sliderOptionsValue = sliderOptions();
          @if (sliderOptionsValue) {
            <ngx-slider
              [(value)]="sliderDate"
              [options]="sliderOptionsValue"
              (userChange)="onSliderChange($event)">
            </ngx-slider>
          }
        } @else if (sliderArchiveOptions() | isNil: false) {
          <ngx-slider
            [(value)]="sliderArchiveDate"
            [options]="sliderArchiveOptions()"
            (userChange)="onSliderChange($event)">
          </ngx-slider>
        }
      </div>
    </div>

    <mat-divider class="route-divider"></mat-divider>

    <!-- Map Sektion (Proportionales Mapbox-Fenster) -->
    @let loadingImagesValue = loadingImages();
    <div class="route-map-card__ratioWrapperMap glass-map-frame">
      @if (showArchiveValue) {
        @let archiveDtgsValue = archiveDtgs();
        @if (routeNameValue && archiveDtgsValue.length > 0) {
          <app-map
            [region]="'de'"
            [zoomPoint]="zoomPoint"
            [mapType]="mapType.ROUTEFCST"
            [dtgs]="archiveDtgsValue"
            [dtgIndex]="archiveDtgIndex()"
            [loadingData]="loadingImagesValue"
            [product]="routeProduct"
            [parameter]="selectedParameterValue"
            [backgroundOpacity]="settingsValue.backgroundOpacity"
            (addressInfo)="onAddressSelect($event)">
          </app-map>
        }
      } @else if (routeNameValue && dtgs.length > 0) {
        <app-map
          [region]="'de'"
          [zoomPoint]="zoomPoint"
          [mapType]="mapType.ROUTEFCST"
          [dtgs]="dtgs"
          [dtgIndex]="dtgIndex"
          [loadingData]="loadingImagesValue"
          [product]="routeProduct"
          [parameter]="selectedParameterValue"
          [backgroundOpacity]="settingsValue.backgroundOpacity"
          (addressInfo)="onAddressSelect($event)"></app-map>
      }
    </div>

    <!-- Kartenlegende am Fuß -->
    <div class="route-legend-footer-zone">
      <app-route-fcst-legend
        [legendToShow]="selectedParameterValue"></app-route-fcst-legend>
    </div>
  </mat-card>
</ng-template>

<ng-template #parameterIcon let-parameter>
  @switch (parameter) {
    @case ('warn') {
      <fa-icon [icon]="['far', 'exclamation-triangle']" size="lg"></fa-icon>
    }
    @case ('rst') {
      <fa-icon [icon]="['far', 'thermometer-half']" size="lg"></fa-icon>
    }

    @case ('rsc') {
      <fa-icon [icon]="['far', 'road']" size="lg"></fa-icon>
    }
  }
</ng-template>

<!--@let settingsValue = settings();
@let showArchiveValue = showArchive();
<mat-drawer-container autosize>
  &lt;!&ndash; Settings &ndash;&gt;
  <mat-drawer #drawer class="settings-sidenav" mode="over" position="end">
    <button mat-icon-button class="close-button" (click)="drawer.toggle()">
      <fa-icon [icon]="['far', 'times']"></fa-icon>
    </button>
    <h3>
      <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon> &nbsp;
      {{ 'HOME.SETTINGS' | translate }}
    </h3>

    &lt;!&ndash; Speed &ndash;&gt;
    <p>
      <b>{{ 'PRODUCT.ROUTEFCST.toolTip.transparent' | translate }}</b>
    </p>
    <div class="opacity-slider">
      <ngx-slider
        [value]="settingsValue.backgroundOpacity"
        [options]="opacityOptions"
        (userChange)="onBackgroundOpacityChange($event)"></ngx-slider>
    </div>

    <mat-divider></mat-divider>
    @if (allowDesignChange()) {
      <p><b>Anordnung</b></p>
      <mat-slide-toggle
        class="toggle-margin"
        color="primary"
        [checked]="settingsValue.designMapLeft"
        (change)="onDesignChange($event)">
        Karte {{ settingsValue.designMapLeft ? 'links' : 'rechts' }}
      </mat-slide-toggle>
      <mat-divider></mat-divider>
    }
    &lt;!&ndash; RESET &ndash;&gt;
    <p align="center">
      <button mat-raised-button color="primary" (click)="onResetSettings()">
        {{ 'PRODUCT.RADAR.RESET' | translate }}
      </button>
    </p>
  </mat-drawer>

  <div class="base-container">
    @let serverErrorValue = serverError();
    <a id="start"></a>

    @if (!serverErrorValue) {
      <div class="flex-flow-wrapper">
        @if (settingsValue.designMapLeft) {
          <ng-container *ngTemplateOutlet="cardMap"></ng-container>
        }
        <ng-container *ngTemplateOutlet="cardInfoBox"></ng-container>
        @if (!settingsValue.designMapLeft) {
          <ng-container *ngTemplateOutlet="cardMap"></ng-container>
        }
        <div style="width: 20px"></div>
      </div>
    }

    @if (serverErrorValue) {
      <mat-card appearance="outlined">
        <fa-icon [icon]="['far', 'exclamation-triangle']" size="lg"></fa-icon>
        &nbsp; Der Server antwortet nicht. Bitte versuchen Sie es später noch
        einmal.
      </mat-card>
    }
  </div>

  &lt;!&ndash; SIDENAV SETTINGS &ndash;&gt;
  <div class="settings-button-stack">
    &lt;!&ndash;settings button&ndash;&gt;
    <button
      mat-mini-fab
      class="settings-button"
      (click)="drawer.toggle()"
      tp="{{ 'HOME.SETTINGS' | translate }}"
      variation="popper"
      trigger="mouseenter"
      tpPlacement="left">
      <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon>
    </button>
    &lt;!&ndash;print button&ndash;&gt;
    <ng-container>
      <app-print-button
        style="display: none"
        #printButtonComponent
        componentName="route-fcst"></app-print-button>
      <ng-content
        *ngTemplateOutlet="
          printButtonComponent.printButtonTemplate()
        "></ng-content>
    </ng-container>
  </div>
</mat-drawer-container>

@let routeNameValue = routeName();
<ng-template #cardInfoBox>
  &lt;!&ndash; Right Card (Infobox) &ndash;&gt;
  <mat-card appearance="outlined" class="radar-info-card">
    <mat-card-header>
      <fa-icon mat-card-avatar [icon]="['far', 'road']" size="2x"></fa-icon>
      <div style="position: absolute; right: 15px">
        <p>
          {{ 'PRODUCT.EPP.LAST_UPDATE' | translate }}:
          {{
            runTimeDtg()
              | datex: 'HH:mm' : undefined : languageService.langSignal()
          }}
        </p>
      </div>
      <mat-card-title>
        {{ routeNameValue }}
      </mat-card-title>
      <mat-card-subtitle>{{
        'PRODUCT.ROUTEFCST.TITLE' | translate
      }}</mat-card-subtitle>
    </mat-card-header>
    @if (detailsData() | isNil: false) {
      <mat-card-content>
        <app-route-fcst-info
          [detailsData]="detailsData()"
          (jumpTo)="onJumpToSituation($event)"
          [stations]="routeProduct['stations']"
          [lastSelectedAddress]="lastSelectedAddress"></app-route-fcst-info>
      </mat-card-content>
    }
  </mat-card>
</ng-template>

<ng-template #cardMap>
  @let selectedParameterValue = selectedParameter();
  &lt;!&ndash; Left Card (Map) &ndash;&gt;
  <mat-card appearance="outlined" class="route-map-card">
    <div class="route-map-card-header">
      &lt;!&ndash; Parameters &ndash;&gt;
      <span class="route-map-card-header&#45;&#45;parameters">
        @for (parameter of routeParameters; track $index) {
          <button
            mat-icon-button
            [ngClass]="[
              parameter === selectedParameterValue
                ? 'parameter-button button-active'
                : 'parameter-button',
              'parameter-button-' + parameter,
            ]"
            (click)="onParameterSelect(parameter)"
            [matTooltip]="'PRODUCT.ROUTEFCST.toolTip.' + parameter | translate">
            <ng-container
              appWmIcon
              [inputParameter]="parameter"
              [additionalClasses]="['ew-icon-size']"></ng-container>
            &lt;!&ndash; <ng-container *ngTemplateOutlet="parameterIcon; context: {$implicit: parameter}"></ng-container> &ndash;&gt;
          </button>
        }
      </span>
      <span
        class="route-map-card-header&#45;&#45;title route-map-card__selected-parameter-title"
        >{{
          'PRODUCT.ROUTEFCST.toolTip.' + selectedParameterValue | translate
        }}</span
      >
      <span
        class="route-map-card-header&#45;&#45;calendar route-map-card__selected-parameter-title">
        <div>
          <mat-slide-toggle
            class="u-margin-bottom-tiny"
            color="primary"
            [checked]="showArchiveValue"
            (change)="onSetShowArchive($event)">
            {{ 'PRODUCT.ROUTEFCST.Archive' | translate }}
          </mat-slide-toggle>
        </div>
        &lt;!&ndash; Calendar &ndash;&gt;
        @if (showArchiveValue) {
          <div>
            <mat-form-field
              appearance="fill"
              subscriptSizing="dynamic"
              (click)="picker.open()"
              class="date-select">
              <mat-label>{{
                'PRODUCT.ROUTEFCST.DATESELECT' | translate
              }}</mat-label>
              <input
                matInput
                [min]="minArchiveDate"
                [max]="maxArchiveDate"
                [formControl]="archiveDateControl"
                [matDatepicker]="picker"
                (dateChange)="onArchiveDateChange($event)" />
              <mat-datepicker-toggle matIconSuffix [for]="picker">
                <fa-icon
                  matDatepickerToggleIcon
                  [icon]="['far', 'calendar-alt']"
                  transform="up-2 shrink-4"
                  size="lg"></fa-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
        }
      </span>
    </div>

    <mat-divider></mat-divider>

    &lt;!&ndash; Slider &ndash;&gt;
    <div class="slider-bar">
      <div class="slider">
        @if (showArchiveValue === false) {
          @let sliderOptionsValue = sliderOptions();
          @if (sliderOptionsValue) {
            <ngx-slider
              [(value)]="sliderDate"
              [options]="sliderOptionsValue"
              (userChange)="onSliderChange($event)">
            </ngx-slider>
          }
        } @else if (sliderArchiveOptions() | isNil: false) {
          <ngx-slider
            [(value)]="sliderArchiveDate"
            [options]="sliderArchiveOptions()"
            (userChange)="onSliderChange($event)">
          </ngx-slider>
        }
      </div>
    </div>
    <mat-divider></mat-divider>

    &lt;!&ndash; Map &ndash;&gt;
    @let loadingImagesValue = loadingImages();
    <div class="route-map-card__ratioWrapperMap">
      @if (showArchiveValue) {
        @let archiveDtgsValue = archiveDtgs();
        @if (routeNameValue && archiveDtgsValue.length > 0) {
          <app-map
            [region]="'de'"
            [zoomPoint]="zoomPoint"
            [mapType]="mapType.ROUTEFCST"
            [dtgs]="archiveDtgsValue"
            [dtgIndex]="archiveDtgIndex()"
            [loadingData]="loadingImagesValue"
            [product]="routeProduct"
            [parameter]="selectedParameterValue"
            [backgroundOpacity]="settingsValue.backgroundOpacity"
            (addressInfo)="onAddressSelect($event)">
          </app-map>
        }
      } @else if (routeNameValue && dtgs.length > 0) {
        <app-map
          [region]="'de'"
          [zoomPoint]="zoomPoint"
          [mapType]="mapType.ROUTEFCST"
          [dtgs]="dtgs"
          [dtgIndex]="dtgIndex"
          [loadingData]="loadingImagesValue"
          [product]="routeProduct"
          [parameter]="selectedParameterValue"
          [backgroundOpacity]="settingsValue.backgroundOpacity"
          (addressInfo)="onAddressSelect($event)"></app-map>
      }
    </div>

    <app-route-fcst-legend
      [legendToShow]="selectedParameterValue"></app-route-fcst-legend>
  </mat-card>
</ng-template>

<ng-template #parameterIcon let-parameter>
  @switch (parameter) {
    @case ('warn') {
      <fa-icon [icon]="['far', 'exclamation-triangle']" size="lg"></fa-icon>
    }
    @case ('rst') {
      <fa-icon [icon]="['far', 'thermometer-half']" size="lg"></fa-icon>
    }

    @case ('rsc') {
      <fa-icon [icon]="['far', 'road']" size="lg"></fa-icon>
    }
  }
</ng-template>-->
